import React, { useEffect } from "react";
import { Dimensions, Platform } from "react-native";
import { Actionsheet, Box, ScrollView, Text, useDisclose } from "native-base";

const ActionSheet = (props: any) => {
  const { children, header, isOpen, onClose } = props;
  const H_INPUT = "50";
  const IS_WEB = Platform.OS === "web";
  const HEIGHT = Dimensions.get("window").height;
  // const { isOpen, onOpen, onClose } = useDisclose();
  // useEffect(() => {
  //   open ? onOpen() : onClose();
  // }, [open]);
  return (
    <Actionsheet
      isOpen={isOpen}
      onClose={onClose}
    >
      <Actionsheet.Content w="100%" >
        {header && (
          <Box w="100%" h={60} px={4} justifyContent="center">
            <Text
              // py="10"
              fontSize="13"
              // textAlign="left"
              color="gray.500"
              _dark={{
                color: "gray.300",
              }}
            >
              {header}
            </Text>
          </Box>
        )}
        <ScrollView w="100%">
          {children &&
            children.map((item: any, i: number) => {
              return (
                <Box w="100%" key={i}>
                  {item}
                </Box>
              );
            })}
        </ScrollView>
      </Actionsheet.Content>
    </Actionsheet>
  );
};

export default ActionSheet;
